<div class="card">
  <h3 class="font-semibold text-base mb-3">History</h3>
  <div class="history-list">
    @if (history.length === 0) {
      <p class="text-grey-500 text-sm">No history yet.</p>
    }
    @for (h of pagedHistory; track h) {
      <div class="entry">
        <p class="font-semibold text-sm">{{h.ChangeDescription}}</p>
        @if (h.PreviousValue) {
          <p class="text-xs text-grey-700">Prev: {{h.PreviousValue}}</p>
        }
        @if (h.CurrentValue) {
          <p class="text-xs text-grey-700">New: {{h.CurrentValue}}</p>
        }
        @if (h.Notes) {
          <p class="text-xs text-grey-700">Notes: {{h.Notes}}</p>
        }
        <p class="text-xs text-grey-500">{{util.humanDate(h.DateOfChange)}}</p>
      </div>
    }
  </div>
  @if (history.length >= 5) {
    <div class="paginator-wrapper">
      <p-paginator
        [rows]="pageSize"
        [totalRecords]="history.length"
        [rowsPerPageOptions]="[5,10,20]"
        [pageLinkSize]="3"
        (onPageChange)="onPageChange($event)">
      </p-paginator>
    </div>
  }
</div>
